import type { SVGProps } from "react";
export interface ChatStarIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ChatStarIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ChatStarIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M4.133 4.133c4.344-4.345 11.39-4.345 15.734 0s4.344 11.39 0 15.734c-3.477 3.477-8.68 4.17-12.847 2.084l-3.17.762c-1.543.37-2.933-1.02-2.563-2.562l.76-3.173C-.037 12.812.657 7.609 4.133 4.133m14.143 1.592a8.875 8.875 0 0 0-12.55 0 8.88 8.88 0 0 0-1.5 10.562c.136.245.175.534.109.807l-.813 3.382 3.385-.811.207-.03c.207-.01.415.038.599.14a8.875 8.875 0 0 0 10.563-14.05"
      />
      <path
        fill={color}
        d="M10.879 7.454a1.376 1.376 0 0 1 2.242 0l.106.177.838 1.667 1.882.27.2.043c.96.284 1.348 1.538.556 2.297l-1.35 1.292.319 1.823c.201 1.158-1.017 1.948-1.984 1.448L12 15.6l-1.686.871c-.967.5-2.185-.29-1.983-1.448l.316-1.823-1.349-1.292c-.845-.81-.347-2.183.756-2.34l1.882-.27.838-1.667zm.802 3.38c-.165.33-.48.558-.845.61l-.672.095.473.453c.27.259.394.636.33 1.005l-.116.663.632-.326.125-.056c.295-.11.625-.09.908.056l.633.326-.116-.663c-.064-.37.06-.746.331-1.005l.472-.453-.67-.095a1.13 1.13 0 0 1-.848-.61L12 10.2l-.318.635Z"
      />
    </svg>
  );
}
